// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sm-search-page {
  padding: 1.25rem;
  max-width: 1400px;
  margin: 0 auto;
}

.page-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

/* ── Filter form ────────────────────────────── */
.filter-form {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 1rem;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
}
.filter-row + .filter-row {
  margin-top: 0.5rem;
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 160px;
  flex: 1 1 160px;
}
.filter-field--checkbox {
  flex: 1 1 230px;
  min-width: 230px;
}
.filter-field .checkbox-control {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  height: 31px;
  cursor: pointer;
}
.filter-field .checkbox-control .sm-checkbox-input {
  margin: 0;
  width: 1rem;
  height: 1rem;
  flex: 0 0 auto;
}
.filter-field--action {
  flex: 0 0 auto;
}
.filter-field--action .btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.field-label {
  font-size: 0.8125rem;
  margin-bottom: 0.25rem;
}

.btn-spinner {
  display: inline-block;
}

/* ── Results ─────────────────────────────────── */
.results-section {
  overflow: hidden;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.75rem;
}

.results-header {
  margin-bottom: 0.25rem;
}

.results-count {
  font-size: 0.875rem;
  color: #6c757d;
}

.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 0.8125rem;
}

.applied-filters__label {
  color: #495057;
  font-weight: 600;
}

.applied-filters__chip {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 999px;
  padding: 0.2rem 0.55rem;
}

.empty-state {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  background: #f8f9fa;
  border: 1px dashed #dee2e6;
  border-radius: 4px;
}

.results-table {
  font-size: 0.8125rem;
  margin-bottom: 0;
}
.results-table thead th {
  white-space: nowrap;
  font-weight: 600;
  background: #f8f9fa;
}
.results-table tbody td {
  background: #fff;
}
.results-table tbody tr:nth-of-type(even) td {
  background: #fcfcfd;
}
.results-table .col-barcode {
  white-space: nowrap;
  font-family: monospace;
}
.results-table .col-date {
  white-space: nowrap;
}
.results-table .col-notes,
.results-table .col-location {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/sample-manager-search-page/sample-manager-search-page.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AACA,kDAAA;AACA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AAEF;AAAE;EACE,kBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAAJ;AAEI;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAAN;AAIE;EACE,cAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAFN;;AAOA;EACE,oBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA,mDAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,gBAAA;AAJF;AAME;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAQE;EACE,mBAAA;AANJ;AASE;EACE,mBAAA;EACA,sBAAA;AAPJ;AAUE;EACE,mBAAA;AARJ;AAWE;;EAEE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATJ","sourcesContent":[".sm-search-page {\n  padding: 1.25rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n/* ── Filter form ────────────────────────────── */\n.filter-form {\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 1rem;\n}\n\n.filter-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: flex-end;\n\n  & + .filter-row {\n    margin-top: 0.5rem;\n  }\n}\n\n.filter-field {\n  display: flex;\n  flex-direction: column;\n  min-width: 160px;\n  flex: 1 1 160px;\n\n  &--checkbox {\n    flex: 1 1 230px;\n    min-width: 230px;\n  }\n\n  .checkbox-control {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.45rem;\n    height: 31px;\n    cursor: pointer;\n\n    .sm-checkbox-input {\n      margin: 0;\n      width: 1rem;\n      height: 1rem;\n      flex: 0 0 auto;\n    }\n  }\n\n  &--action {\n    flex: 0 0 auto;\n\n    .btn {\n      display: flex;\n      align-items: center;\n      gap: 0.4rem;\n    }\n  }\n}\n\n.field-label {\n  font-size: 0.8125rem;\n  margin-bottom: 0.25rem;\n}\n\n.btn-spinner {\n  display: inline-block;\n}\n\n/* ── Results ─────────────────────────────────── */\n.results-section {\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 0.75rem;\n}\n\n.results-header {\n  margin-bottom: 0.25rem;\n}\n\n.results-count {\n  font-size: 0.875rem;\n  color: #6c757d;\n}\n\n.applied-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  font-size: 0.8125rem;\n}\n\n.applied-filters__label {\n  color: #495057;\n  font-weight: 600;\n}\n\n.applied-filters__chip {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 999px;\n  padding: 0.2rem 0.55rem;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 2rem;\n  color: #6c757d;\n  background: #f8f9fa;\n  border: 1px dashed #dee2e6;\n  border-radius: 4px;\n}\n\n.results-table {\n  font-size: 0.8125rem;\n  margin-bottom: 0;\n\n  thead th {\n    white-space: nowrap;\n    font-weight: 600;\n    background: #f8f9fa;\n  }\n\n  tbody td {\n    background: #fff;\n  }\n\n  tbody tr:nth-of-type(even) td {\n    background: #fcfcfd;\n  }\n\n  .col-barcode {\n    white-space: nowrap;\n    font-family: monospace;\n  }\n\n  .col-date {\n    white-space: nowrap;\n  }\n\n  .col-notes,\n  .col-location {\n    max-width: 260px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
